export const Months = [
    {
        label: 'ENE',
        selected: false,
        nameLarge: 'Enero',
        value: 0
    },
    {
        label: 'FEB',
        selected: false,
        nameLarge: 'Febrero',
        value: 1
    },
    {
        label: 'MAR',
        selected: false,
        nameLarge: 'Marzo',
        value: 2
    },
    {
        label: 'ABR',
        selected: false,
        nameLarge: 'Abril',
        value: 3
    },
    {
        label: 'MAY',
        selected: false,
        nameLarge: 'Mayo',
        value: 4
    },
    {
        label: 'JUN',
        selected: false,
        nameLarge: 'Junio',
        value: 5
    },
    {
        label: 'JUL',
        selected: false,
        nameLarge: 'Julio',
        value: 6
    },
    {
        label: 'AGO',
        selected: false,
        nameLarge: 'Agosto',
        value: 7
    },
    {
        label: 'SET',
        selected: false,
        nameLarge: 'Septiembre',
        value: 8
    },
    {
        label: 'OCT',
        selected: false,
        nameLarge: 'Octubre',
        value: 9
    },
    {
        label: 'NOV',
        selected: false,
        nameLarge: 'Noviembre',
        value: 10
    },
    {
        label: 'DIC',
        selected: false,
        nameLarge: 'Diciembre',
        value: 11
    }
]